<template>
    <div class="nav-warpper">
        <div class="padding-top-xl flex align-center justify-around">
            <img alt="" class="margin-bottom-sm" src="../assets/img/avatar.png"/>
        </div>
        <h2 class="user-name margin-bottom">{{ user ? user.user_name : ''}}</h2>
        <div v-for="(item, index) in nav" :key="index">
            <div v-if="item.leaf">
                <div :class="{ 'is-active': item.path === navPath }" class="menu-item">
                    <div @click="navTab(1, index, -1, item.path)">
                        <i :class="item.icon" class="iconfont"> </i>
                        {{ item.name }}
                        <el-badge style="padding-left: 0" :value="item.id === 1 ? userExamineNum : item.id === 12 ? creaditExamineNum : 0" :max="99"
                                  :hidden="!(item.id === 1 ? userExamineNum : item.id === 12 ? creaditExamineNum : 0)">
                        </el-badge>
                    </div>
                    <i class="iconfont icon-biaoqing-copy"></i>
                </div>
                <el-collapse-transition>
                    <ul v-show="item.state">
                        <li v-for="(child, cindex) in item.child" :key="cindex">
                            <div
                                v-if="child.power.indexOf(user.power) !== -1"
                                :class="{ 'is-active': child.path === navPath }"
                                class="menu-item-two"
                            >
                                <div @click="navTab(2, index, cindex, child.path)">
                                    {{ child.name }}
                                </div>
                            </div>
                        </li>
                    </ul>
                </el-collapse-transition>
            </div>

            <div v-else>
                <div :class="{ 'is-active': item.path === navPath }" class="menu-item">
                    <div @click="navTab(1, index, -1, item.path)">
                        <i :class="item.icon" class="iconfont"> </i>
                        {{ item.name }}
                        <el-badge style="padding-left: 0" :value="item.id === 1 ? userExamineNum : item.id === 12 ? creaditExamineNum : 0" :max="99"
                                  :hidden="!(item.id === 1 ? userExamineNum : item.id === 12 ? creaditExamineNum : 0)">
                        </el-badge>
                    </div>
                    <i class="iconfont icon-biaoqing-copy"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getExamineNum} from "@/api/admin";

export default {
    name: "nav-modular",
    data() {
        return {
            userExamineNum:0,
            creaditExamineNum:0,
        }
    },
    props: {
        navPath: {
            type: String
        }
    },
    created() {
        this.nav.map((item, index) => {
            item.child.map(items => {
                if (items.path === this.navPath) {
                    this.$set(this.nav[index], 'state', true)
                }
            })
        })
        if (this.user.user_type === 2) {
            this.init()
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        nav() {
            if (this.user.user_type === 1) {
                if (this.user.user_info_state === 1) {
                    return [
                        {
                            id: 1,
                            name: '会员首页',
                            path: '/home/index',
                            icon: 'icon-shouye',
                            child: [],              //  {id: 8, name: 'XX', path: '/home/XX', child: [], leaf: false},
                            leaf: false,            //  是否有二级
                        },
                        {
                            id: 6,
                            name: '基础信息',
                            path: '/home/info2',
                            icon: 'icon-jibenxinxi1',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 11,
                            name: '综合信息',
                            path: '/home/credit',
                            icon: 'icon-jibenxinxi1',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 4,
                            name: '查看证书',
                            path: '/home/certificate',
                            icon: 'icon-zhengshu-copy',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 5,
                            name: '续期申请',
                            path: '/home/renew',
                            icon: 'icon-jiaofei',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 3,
                            name: '变更信息',
                            path: '/home/infoup',
                            icon: 'icon-jibenxinxi1',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 5,
                            name: '通知公告',
                            path: '/home/notice',
                            icon: 'icon-gonggao',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 10,
                            name: '常见问题',
                            path: '/home/question',
                            icon: 'icon-gonggao',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 17,
                            name: '缴费记录',
                            path: '/home/paymentRecord',
                            icon: 'icon-zhanghao',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 4,
                            name: '账号管理',
                            path: '/home/account',
                            icon: 'icon-zhanghao',
                            child: [],
                            leaf: false,
                        },
                    ]
                } else {
                    return [
                        {
                            id: 1,
                            name: '会员首页',
                            path: '/home/index',
                            icon: 'icon-shouye',
                            child: [],              //  {id: 8, name: 'XX', path: '/home/XX', child: [], leaf: false},
                            leaf: false,            //  是否有二级
                        },
                        {
                            id: 2,
                            name: '入会申请',
                            path: '/home/info',
                            icon: 'icon-jibenxinxi1',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 6,
                            name: '基础信息',
                            path: '/home/info2',
                            icon: 'icon-jibenxinxi1',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 11,
                            name: '综合信息',
                            path: '/home/credit',
                            icon: 'icon-jibenxinxi1',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 4,
                            name: '查看证书',
                            path: '/home/certificate',
                            icon: 'icon-zhengshu-copy',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 5,
                            name: '续期申请',
                            path: '/home/renew',
                            icon: 'icon-jiaofei',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 5,
                            name: '通知公告',
                            path: '/home/notice',
                            icon: 'icon-gonggao',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 10,
                            name: '常见问题',
                            path: '/home/question',
                            icon: 'icon-gonggao',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 4,
                            name: '账号管理',
                            path: '/home/account',
                            icon: 'icon-zhanghao',
                            child: [],
                            leaf: false,
                        },
                    ]
                }

            } else {
                if (this.user.user_role === 0) {
                    return [
                        {
                            id: 1,
                            name: '会员审核',
                            path: '/admin/examine',
                            icon: 'icon-jibenxinxi1',
                            child: [],              //  {id: 8, name: 'XX', path: '/home/XX', child: [], leaf: false},
                            leaf: false,            //  是否有二级
                        },
                        {
                            id: 2,
                            name: '会员管理',
                            path: '/admin/member',
                            icon: 'icon-yonghu',
                            child: [],
                            leaf: false,
                        },
                        //  TODO 在线缴费
                        {
                            id: 11,
                            name: '信用管理',
                            path: '/admin/creditList',
                            icon: 'icon-yonghu',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 3,
                            name: '预备会员',
                            path: '/admin/prepare',
                            icon: 'icon-daiyue',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 4,
                            name: '会员联系',
                            path: '/admin/labels',
                            icon: 'icon-biaoqian',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 5,
                            name: '通知公告',
                            path: '/admin/notice',
                            icon: 'icon-gonggao',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 6,
                            name: '发送记录',
                            path: '/admin/record',
                            icon: 'icon-shouji',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 15,
                            name: '月报记录',
                            path: '/admin/monthRecord',
                            icon: 'icon-shouji',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 7,
                            name: '会员统计',
                            path: '/admin/statistics',
                            icon: 'icon-tongji',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 8,
                            name: '密码修改',
                            path: '/admin/pass',
                            icon: 'icon-mima',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 10,
                            name: '常见问题',
                            path: '/admin/question',
                            icon: 'icon-gonggao',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 9,
                            name: '账号管理',
                            path: '/admin/account',
                            icon: 'icon-zhanghao',
                            child: [],
                            leaf: false,
                        },
                    ]
                } else if (this.user.user_role === 4) {
                    return [
                        {
                            id: 1,
                            name: '会员审核',
                            path: '/admin/examine',
                            icon: 'icon-jibenxinxi1',
                            child: [],              //  {id: 8, name: 'XX', path: '/home/XX', child: [], leaf: false},
                            leaf: false,            //  是否有二级
                        },
                        {
                            id: 2,
                            name: '会员管理',
                            path: '/admin/member',
                            icon: 'icon-yonghu',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 11,
                            name: '信用管理',
                            path: '/admin/creditList',
                            icon: 'icon-yonghu',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 3,
                            name: '预备会员',
                            path: '/admin/prepare',
                            icon: 'icon-daiyue',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 4,
                            name: '会员联系',
                            path: '/admin/labels',
                            icon: 'icon-biaoqian',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 5,
                            name: '通知公告',
                            path: '/admin/notice',
                            icon: 'icon-gonggao',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 6,
                            name: '发送记录',
                            path: '/admin/record',
                            icon: 'icon-shouji',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 15,
                            name: '月报记录',
                            path: '/admin/monthRecord',
                            icon: 'icon-shouji',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 7,
                            name: '会员统计',
                            path: '/admin/statistics',
                            icon: 'icon-tongji',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 8,
                            name: '密码修改',
                            path: '/admin/pass',
                            icon: 'icon-mima',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 10,
                            name: '常见问题',
                            path: '/admin/question',
                            icon: 'icon-gonggao',
                            child: [],
                            leaf: false,
                        }
                    ]
                } else if (this.user.user_role === 1){
                    return [
                        {
                            id: 1,
                            name: '会员审核',
                            path: '/admin/examine',
                            icon: 'icon-jibenxinxi1',
                            child: [],              //  {id: 8, name: 'XX', path: '/home/XX', child: [], leaf: false},
                            leaf: false,            //  是否有二级
                        },
                        {
                            id: 2,
                            name: '会员管理',
                            path: '/admin/member',
                            icon: 'icon-yonghu',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 12,
                            name: '信用审核',
                            path: '/admin/creditExamineList',
                            icon: 'icon-jibenxinxi1',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 11,
                            name: '信用管理',
                            path: '/admin/creditList',
                            icon: 'icon-yonghu',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 3,
                            name: '预备会员',
                            path: '/admin/prepare',
                            icon: 'icon-daiyue',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 4,
                            name: '会员联系',
                            path: '/admin/labels',
                            icon: 'icon-biaoqian',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 5,
                            name: '通知公告',
                            path: '/admin/notice',
                            icon: 'icon-gonggao',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 13,
                            name: '缴费记录',
                            path: '/admin/paymentRecord',
                            icon: 'icon-gonggao',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 6,
                            name: '发送记录',
                            path: '/admin/record',
                            icon: 'icon-shouji',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 15,
                            name: '月报记录',
                            path: '/admin/monthRecord',
                            icon: 'icon-shouji',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 7,
                            name: '会员统计',
                            path: '/admin/statistics',
                            icon: 'icon-tongji',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 10,
                            name: '常见问题',
                            path: '/admin/question',
                            icon: 'icon-gonggao',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 8,
                            name: '密码修改',
                            path: '/admin/pass',
                            icon: 'icon-mima',
                            child: [],
                            leaf: false,
                        },
                    ]
                }else {
                    return [
                        {
                            id: 1,
                            name: '会员审核',
                            path: '/admin/examine',
                            icon: 'icon-jibenxinxi1',
                            child: [],              //  {id: 8, name: 'XX', path: '/home/XX', child: [], leaf: false},
                            leaf: false,            //  是否有二级
                        },
                        {
                            id: 2,
                            name: '会员管理',
                            path: '/admin/member',
                            icon: 'icon-yonghu',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 11,
                            name: '信用管理',
                            path: '/admin/creditList',
                            icon: 'icon-yonghu',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 3,
                            name: '预备会员',
                            path: '/admin/prepare',
                            icon: 'icon-daiyue',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 4,
                            name: '会员联系',
                            path: '/admin/labels',
                            icon: 'icon-biaoqian',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 5,
                            name: '通知公告',
                            path: '/admin/notice',
                            icon: 'icon-gonggao',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 6,
                            name: '发送记录',
                            path: '/admin/record',
                            icon: 'icon-shouji',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 15,
                            name: '月报记录',
                            path: '/admin/monthRecord',
                            icon: 'icon-shouji',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 7,
                            name: '会员统计',
                            path: '/admin/statistics',
                            icon: 'icon-tongji',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 10,
                            name: '常见问题',
                            path: '/admin/question',
                            icon: 'icon-gonggao',
                            child: [],
                            leaf: false,
                        },
                        {
                            id: 8,
                            name: '密码修改',
                            path: '/admin/pass',
                            icon: 'icon-mima',
                            child: [],
                            leaf: false,
                        },
                    ]
                }
            }

        },
    },
    components: {},
    methods: {
        navTab(type, index, cindex, path) {
            let _path = path ? path : (this.user.power === 6 ? '/home/info' : '/home/account')
            if (type === 1) {
                this.$router.push(_path)
                if (this.nav[index].leaf) {
                    this.nav.map(item => item.state = false)
                    this.$set(this.nav[index], 'state', !this.nav[index].state)
                }
            } else {
                this.nav.map(item => item.state = false)
                this.$set(this.nav[index], 'state', !this.nav[index].state)
                this.$router.push(_path)
            }
        },
        async init(){
            let _data = await getExamineNum()
            this.userExamineNum = this.user.user_role === 1 ? _data.data.jb_userExamineNum : this.user.user_role === 2  ? _data.data.sh_userExamineNum : _data.data.sp_userExamineNum
            this.creaditExamineNum = _data.data.creaditExamineNum
        }
    },
    filters: {},
    watch: {
        navPath() {
            this.nav.map((item, index) => {
                item.child.map(items => {
                    if (items.path === this.navPath) {
                        this.$set(this.nav[index], 'state', true)
                    }
                })
            })

        }
    },
}
</script>

<style lang="scss" scoped>
.nav-warpper {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 260px;
    background: #03143f;
    overflow: auto;

    .user-name {
        text-align: center;
        font-size: 20px;
        color: #fff;
        padding: 0 20px;
    }

    .menu-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 55px;
        font-size: 18px;
        color: #fff;
        cursor: pointer;
        padding-right: 30px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);

        &.is-active {
            background: #0d7fd7;
            color: #fff;

            i {
                color: #fff;
            }
        }

        div {
            flex: 1;
            padding-left: 30px;
            height: 54px;
            line-height: 54px;

            img {
                width: 18px;
                margin-right: 8px;
            }
        }

        i {
            font-size: 20px;
            color: #51bed7;
            font-weight: bold;
            margin-right: 5px;

            &.icon-biaoqing-copy {
                color: #fff;
                font-size: 16px;
            }
        }
    }

    .menu-item-two {
        display: flex;
        align-items: center;
        height: 55px;
        font-size: 18px;
        color: #fff;
        cursor: pointer;

        &.is-active {
            background: #d00000;
        }

        div {
            flex: 1;
            padding-left: 60px;
            height: 54px;
            line-height: 54px;
        }
    }
}
</style>